import WithResponsiveRendering from "@/modules/common/components/wrappers/with-responsive-rendering";
import DesktopPropertyTrackTabs from "./desktop";
import MobilePropertyTrackTabs from "./mobile";

export interface PropertyTrackTabsProps {
  selectedTab: string;
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  isConstructionTabVisible: boolean;
  subPropertiesTabVisible: boolean;
  isListingVisible: boolean;
  isInterestsVisible: boolean;
  isTenantsVisible: boolean;
}

const PropertyTrackTabs = WithResponsiveRendering({
  DesktopComponent: DesktopPropertyTrackTabs,
  MobileComponent: MobilePropertyTrackTabs,
});

export default PropertyTrackTabs;
